// src/public/rsvp/parts/rsvpCompactSx.js
export const compactAccordionSx = {
  borderRadius: '8px !important',
  overflow: 'hidden',
  boxShadow: 'none',
  border: '1px solid rgba(0,0,0,0.08)',

  // ❌ bunu kaldır
  // marginBottom: '6px',
  // '&:last-of-type': { marginBottom: 0 },

  '&:before': { display: 'none' },

  '& .MuiAccordionSummary-root': {
    minHeight: 40,
    px: 1,
    py: 0.5,
  },

  '& .MuiAccordionSummary-content': {
    my: 0,
    '&.Mui-expanded': { my: 0 },
  },

  '& .MuiAccordionDetails-root': {
    px: 1,
    pt: 0,
    pb: 0.75,
  },
};

export const compactTitleSx = { fontWeight: 800, fontSize: 13, lineHeight: 1.1 };
export const compactSubSx = { opacity: 0.72, fontSize: 11.5, lineHeight: 1.15 };

export const compactRowSx = {
  fontSize: 12.5,
  lineHeight: 1.25,
  opacity: 0.88,
  '& b': { fontWeight: 800 },
};
